
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/integrations/material-ui",
      function () {
        return require("private-next-pages/joy-ui/integrations/material-ui.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/integrations/material-ui"])
      });
    }
  